import styled from 'styled-components'
import { CheckmarkCircle, CloseCircle } from 'components/Icons'

export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`

export const AcceptIcon = styled(CheckmarkCircle).attrs(() => ({
  width: '16px',
  height: '16px',
}))`
  margin-right: 4px;
`

export const RejectIcon = styled(CloseCircle).attrs(() => ({
  width: '16px',
  height: '16px',
}))`
  margin-right: 4px;
`
